import { Contact } from './contact';

export class MailList {
    _id: string;
    name: string;
    contacts: Contact[];

    constructor(data) {
        Object.assign(this, data);

        this.contacts = this.contacts.map(_contact => new Contact(_contact));
    }

    get contactCount() {
        return this.contacts.length;
    }

    toString() {
        return `${this.name} (${this.contacts.length})`;
    }
}